import script from "./PriceCategoriesForSecondAgent.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceCategoriesForSecondAgent.vue?vue&type=script&setup=true&lang=js"

import "./PriceCategoriesForSecondAgent.vue?vue&type=style&index=0&id=62628272&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62628272"]])

export default __exports__